module.exports = __webpack_public_path__ + "static/img/6.12a2f72.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/6.jpg
// module id = H69U
// module chunks = 1